// Convert raw stored note content into human-readable text.
// - JSON objects → "Key: value · Key: value" (empty fields skipped, camel/snake → Title Case)
// - JSON arrays of primitives → comma-separated
// - Mention tokens like "@[Name](client:uuid)" → "@Name"
// - Plain strings pass through unchanged.

const titleCase = (k: string) =>
  k.replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

const stripMentions = (s: string) =>
  s.replace(/@\[([^\]]+)\]\([^:]+:[^)]+\)/g, '@$1');

const formatValue = (v: unknown): string => {
  if (v === null || v === undefined) return '';
  if (Array.isArray(v)) return v.map(formatValue).filter(Boolean).join(', ');
  if (typeof v === 'object') {
    return Object.entries(v as Record<string, unknown>)
      .filter(([, vv]) => vv !== null && vv !== undefined && String(vv).trim() !== '')
      .map(([k, vv]) => `${titleCase(k)}: ${formatValue(vv)}`)
      .join(' · ');
  }
  return String(v);
};

export const formatNoteText = (content: string | null | undefined): string => {
  if (!content) return '';
  const trimmed = content.trim();
  const looksJson =
    (trimmed.startsWith('{') && trimmed.endsWith('}')) ||
    (trimmed.startsWith('[') && trimmed.endsWith(']'));
  if (looksJson) {
    try {
      const parsed = JSON.parse(trimmed);
      const formatted = formatValue(parsed);
      if (formatted) return formatted;
    } catch {
      /* fall through */
    }
  }
  return stripMentions(content);
};
